/* W-053 step 3a (2026-10-07) -- the user-management vocabulary, ONE owner for the client.

   ROLE_DESCRIPTIONS (Brian, 10-07): every place a role is picked shows these lines, and the Role column's tooltip shows both.
   ASSIGNABLE_ROLES: the two roles a company login can hold. 'super_admin' is never assignable from the app (the server
   refuses it with ROLE_SUPER_ADMIN).

   PASSWORD_RULE is a CLIENT COPY of server.js PASSWORD_RULE (the server owns the rule and checks it; the client only shows
   it before the first attempt). It is a WALL-MIRROR pair (M13): server/diagnostics/verify-wall-mirrors.js fails the build
   if the two strings ever differ. Edit both together. */

export const ASSIGNABLE_ROLES = ['admin', 'viewer'];

export const ROLE_LABELS = {
  admin: 'Admin',
  viewer: 'Viewer',
  super_admin: 'Super Admin',
};

export const ROLE_DESCRIPTIONS = {
  admin: "Can view and edit everything in the company's model, and add, change or remove users.",
  viewer: 'Can view everything. Can only create, edit and share their own scenarios.',
};

export const roleLabel = role => ROLE_LABELS[role] || role || '';

/* "Admin -- Can view and edit ..." : the text of a role option wherever a role is picked. */
export const roleOptionText = role => roleLabel(role) + ' — ' + (ROLE_DESCRIPTIONS[role] || '');

/* The Role column header's tooltip: both descriptions. */
export const ROLE_TOOLTIP = ASSIGNABLE_ROLES.map(r => roleLabel(r) + ': ' + ROLE_DESCRIPTIONS[r]).join('\n');

export const PASSWORD_RULE = 'At least 12 characters, at most 72 bytes (72 plain letters; fewer with accented letters or emoji), and different from your current password.';

/* A login's status, as the Add User table shows it. */
export const userStatus = u => (!u.is_active ? 'Deactivated' : u.must_change_password ? 'Must set password' : 'Active');
